<div class="container animated fadeIn">
    <div class="row">
        <div class="col-12">
            <div class="fadeTitle">
                <h3 class="fw-sbold fs-30">¡Cuéntanos acerca de tu empresa!</h3>
                <p class="fs-14">En esta sección te solicitaremos información básica sobre tu empresa</p>
            </div>

            <form [formGroup]="secondFormDev" (ngSubmit)="nextStep()" class="fadeForm">

                <ng-container>
                    <div class="my-4 mt-5 col-12 col-sm-10 col-md-9 col-lg-10 col-xl-7">
                        <mnf-input-form class="fs-1" formControlName="company" label="¿Cuál es el nombre tu empresa?" placeholder="MONIFIC S.A DE C.V" errMsg="Debe estar lleno éste campo" [specialCharacters]="['.', ',']"></mnf-input-form>
                    </div>
                    <div class="my-4">
                        <label class="mnf-control-label">¿Cómo opera actualmente tu empresa?</label>
                        <mat-radio-group formControlName="statusOperateCompany" class="mat-block">
                           <mat-radio-button [value]="rfcOptions[0]" rfcOptions>Persona Física</mat-radio-button>
                           <mat-radio-button [value]="rfcOptions[1]" class="ms-0">Persona Moral</mat-radio-button>
                           <mat-radio-button [value]="rfcOptions[2]" class="ms-0">Otros</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </ng-container>

                <div class="d-block d-xl-flex my-3 fadeShow" *ngIf="forms.statusOperateCompany.value === 'Persona Fisica' || forms.statusOperateCompany.value === 'Persona Moral'">
                    <div class="col-12 col-sm-10 col-md-10 col-xl-5">
                        <mnf-input-form class="adjust-text" formControlName="rfc" label="RFC de tu empresa" placeholder="AAA 000000" mask="UUU 000000" errMsg="Debe estar lleno éste campo"></mnf-input-form>
                    </div>
                    <div class="col-12 col-sm-10 col-md-10 col-xl-4 ms-xl-3">
                        <mnf-input-form class="adjust-text" formControlName="homoclave" label="Homoclave" placeholder="AAA" mask="AAA" errMsg="Debe estar lleno éste campo"></mnf-input-form>
                    </div>
                </div>

                <div class="my-3">
                    <div class="col-12 col-sm-10 col-md- col-lg-10 col-xl-7">
                        <label class="mnf-control-label">¿En que país se encuentrán constituidos?</label>
                        <mat-form-field appearance="outline" class="mnf-select">
                           <mat-select disableRipple formControlName="constitutionCountry">
                              <mat-option value="">Seleccionar</mat-option>
                              <mat-option [value]="c.value" *ngFor="let c of countries" [title]="c.value">
                                 {{ c.value }}
                              </mat-option>
                           </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="my-3 col-12 col-sm-10 col-md- col-lg-10 col-xl-7">
                    <mnf-input-form formControlName="addressCompany" label="¿En que dirección se encuentra tu empresa?" placeholder="Interior 1601 Boulevard Manuel Ávila Camacho #118 Piso 16" errMsg="Debe estar lleno éste campo"></mnf-input-form>
                </div>

                <div class="my-3">
                    <label class="mnf-control-label">¿Tu empresa cuenta con sitio web?</label>
                    <mat-radio-group formControlName="haveWebSites">
                       <mat-radio-button [value]="defaultOptions[0]" defaultOptions>Sí</mat-radio-button>
                       <mat-radio-button [value]="defaultOptions[1]" class="ms-4">No</mat-radio-button>
                    </mat-radio-group>
                </div>

                <div class="my-4 col-12 col-sm-10 col-md- col-lg-10 col-xl-7 fadeShow" *ngIf="forms.haveWebSites.value === 'Si'">
                    <mnf-input-form formControlName="website" label="¡Compártenos la página de internet de tu empresa!" [specialCharacters]="['@', '-', '_', '/', '.', ',', ':']" placeholder="https://www.monific.com/" errMsg="Debe estar lleno éste campo"></mnf-input-form>
                </div>

                <div class="col-12 col-sm-10 col-md- col-lg-10 col-xl-7 my-3 mt-4">
                    <mnf-input-form formControlName="phone" label="¿Cuál es tu número de teléfono?" placeholder="00 0000 0000" errMsg="Debe estar lleno éste campo" mask="00 0000 0000"></mnf-input-form>
                </div>

                <div class="my-3 col-12 col-md-9 col-lg-8 col-xl-7">
                    <label class="mnf-control-label">¿La propiedad que pretendes fondear estar a nombre de una persona moral?</label>
                    <mat-radio-group formControlName="foundedMoralPerson">
                       <mat-radio-button [value]="defaultOptions[0]" defaultOptions>Sí</mat-radio-button>
                       <mat-radio-button [value]="defaultOptions[1]" class="ms-4">No</mat-radio-button>
                    </mat-radio-group>
                </div>

                <div class="my-5">
                    <button mat-button (click)="returnToStep()"> ❮ </button>
                    <button mat-button type="submit" [disabled]="!secondFormDev.valid" class="ms-3"> ❯ </button>
                </div>

            </form>

        </div>
    </div>
</div>
